import { render, staticRenderFns } from "./moveFolder.vue?vue&type=template&id=60b55441&"
import script from "./moveFolder.vue?vue&type=script&lang=js&"
export * from "./moveFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports